import { RiskVersionViewModel } from "./RiskAssessmentVersions.types";
import { useState } from "react";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export default function useRiskAssessmentVersionsDataMapping() {
    const [selectedVersion, setSelectedVersion] = useState<RiskVersionViewModel | undefined>(undefined);
    const [showChangeLockedStatusDialog, setShowChangeLockedStatusDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [versionForEdit, setVersionForEdit] = useState<RiskVersionViewModel | undefined>(undefined);

    const url = "/riskassesmentversions";
    let { isLoading, data, refetch } = useDotLegalQuery<Array<RiskVersionViewModel>>(url);

    const onSave = () => {
        refetch();
    };

    const onDelete = () => {
        refetch();
        setShowDeleteDialog(false);
        setSelectedVersion(undefined);
    };

    return {
        isLoading,
        data,
        selectedVersion,
        setSelectedVersion,
        showChangeLockedStatusDialog,
        setShowChangeLockedStatusDialog,
        onSave,
        showDeleteDialog,
        setShowDeleteDialog,
        onDelete,
        versionForEdit,
        setVersionForEdit,
    };
}
